import { locales } from '@@/shared-components/locales/index'

export const publicCityQuery = ({
  id,
  query,
  thumbs = {
    list: { h: 500, w: 500, q: 90, fit: 'fill', fm: 'webp' },
  },
  dataLang,
}: {
  id: Ref<string | number>
  query?: Ref<object>
  thumbs?: {
    [key: string]: object
  }
  dataLang: Ref<ValueOf<typeof locales>>
}) =>
  queryOptions({
    queryKey: ['cities', id, dataLang, query],
    retry: 0,
    queryFn: async ({
      signal,
    }): Promise<{ data: { article: Article; wildcards: { [key: string]: unknown } } }> =>
      await useCustomFetch<{
        data: { article: Article; wildcards: { [key: string]: unknown } }
      }>({
        url: `/public/seo/cities/${id.value}`,
        query: {
          ...query?.value,
        },
        options: { headers: { 'X-Lang': dataLang.value } },
        thumbs,
        signal,
        clientOnly: true,
      }),
  })
